<script setup lang="tsx">
import configEditor from '@/stores/jira-config-editor'
import http from '@/services/http'
import { computed, ref } from 'vue'
import type { EditJiraDomainRequest, Response } from '@/models/api-generated'
import axios from 'axios'
import i18n from '@/i18n'
import toastStore from '@/stores/toast'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const toaster = toastStore()
const props = defineProps({
	isValid: Boolean,
})

const store = configEditor()
const { resetChanges } = store
const canSave = computed(() => store.changeCount > 0 && !savingInProgress.value && props.isValid)
const emit = defineEmits(['domain-edited'])
const savingInProgress = ref(false)
const cancel = () => {
	resetChanges()
	emit('domain-edited')
}

const save = async () => {
	if (store.changes.length) {
		savingInProgress.value = true
		const reqBody = {
			domainConfig: store.changes.map(({ id, domain, admin, instance, isActive, apiToken, email, status, parentDomainId }) => ({
				id,
				domain,
				admin,
				instance,
				isActive,
				apiToken,
				email,
				status,
				parentDomainId,
			})),
		}
		const data = await http.post<Response<EditJiraDomainRequest>>('/api/jira/editDomainConfigs', reqBody)
		if (data.status === axios.HttpStatusCode.Ok) {
			toaster.showSuccess(t('jira.domainsEdited'))
			resetChanges()
			emit('domain-edited')
		}
		savingInProgress.value = false
	}
}
const getTooltipMessage = () => {
	if (!props.isValid) {
		return i18n.global.t('jira.fieldIsRequired')
	}
	return ''
}
</script>

<template>
	<div v-if="store.changeCount > 0" class="container fixed-bottom mb-4">
		<div class="row">
			<div class="col"></div>
			<div class="col text-center">
				<div class="d-inline-flex justify-content-between toolbar text-nowrap">
					<button
						id="cancel-config-edit-btn"
						class="btn btn-close me-3 mt-2"
						@click="cancel"
						:aria-label="$t('misc.cancel')"
						role="button"
					></button>
					<div v-one-tooltip="getTooltipMessage()">
						<button
							id="save-config-edit-btn"
							class="btn btn-primary"
							:disabled="!canSave"
							@click="save"
							:aria-label="$t('misc.save')"
							role="button"
						>
							<i class="bi bi-floppy"></i>
							{{ $t('misc.save') }}: {{ store.changeCount }}
						</button>
					</div>
				</div>
			</div>
			<div class="col"></div>
		</div>
	</div>
</template>
